<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePackageManagementStore } from '@/store/PackageManagementStore';
import { useToast } from 'primevue/usetoast';
import InputText from 'primevue/inputtext';

interface Props {
  worksheetData: any;
  permission?: boolean;
}
defineProps<Props>();

const emits = defineEmits<{ changeLinkedQuote: [value: any] }>();

const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const packageStore = usePackageManagementStore();
const editLinkedQuotes = ref({
  isEdit: false,
  data: ''
});

const handleSaveLinkedQuotes = (linkedQuote: string) => {
  const payloadCheck = linkedQuote?.replace(/\s+/g, '');
  packageStore
    .getCheckingQuoteIds(payloadCheck)
    .then((res) => {
      if (res.status == 200) {
        const convertToArray = linkedQuote?.length ? linkedQuote.split(',').map((item: any) => item.trim()) : [];
        emits('changeLinkedQuote', convertToArray);
      }
    })
    .catch(() => {
      toast.add({ severity: 'error', summary: '', detail: t('worksheet.quote_not_exist'), life: 5000 });
    })
    .finally(() => {
      editLinkedQuotes.value.isEdit = false;
    });
};

const convertString = (quoteIds: any) => {
  return quoteIds?.join(', ');
};
</script>
<template>
  <div class="linked-quote font-bold">
    <div class="grid" v-if="!editLinkedQuotes.isEdit">
      <div class="flex w-full">
        <div class="col-6">{{ $t('worksheet.linked_quotes') }}:</div>
        <div class="flex">
          <div class="col-10 font-normal">{{ convertString(worksheetData?.linkedQuotes) }}</div>
          <span class="text-center col-2">
            <i v-if="permission" class="pi pi-pencil cursor-pointer" @click="editLinkedQuotes = { isEdit: true, data: convertString(worksheetData?.linkedQuotes) }"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="grid" v-else>
      <div class="flex justify-content-start align-items-start">
        <div class="col-5">{{ $t('worksheet.linked_quotes') }}:</div>
        <div class="flex col-9">
          <div class="col-6 font-normal"><InputText class="w-full" v-model="editLinkedQuotes.data" /></div>
          <div class="col-4 text-center flex gap-2 align-items-center">
            <i class="pi pi-check cursor-pointer" @click="handleSaveLinkedQuotes(editLinkedQuotes.data)"></i>
            <i class="pi pi-times cursor-pointer" @click="editLinkedQuotes = { isEdit: false, data: worksheetData?.linkedQuotes }"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
